import React from "react";
import classNames from "classnames";

export default class Summary extends React.Component {
  render() {
    const { horizontal } = this.props;

    return (
      <div className={ classNames("summary", this.props.className, { horizontal }) }>
        { this.props.children }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/Summary/Summary.jsx